module.exports = __webpack_public_path__ + "static/416-5acc8aeb10a0921996d34d8cd3a6ba31.png";